var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "84px",
    viewBox: "0 0 119 84",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "resize") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M119,30.4277344 L119,79 C119,81.7614237 116.761424,84 114,84 L5,84 C2.23857625,84 -2.84217094e-14,81.7614237 -2.84217094e-14,79 L-2.84217094e-14,5 C-2.84217094e-14,2.23857625 2.23857625,0 5,0 L84.3476562,0",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 119,
    height: 84,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "00_resolution",
    transform: "translate(-215.000000, -275.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "resize",
    transform: "translate(215.000000, 275.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,31 C4.44771525,31 4,31.4477153 4,32 L4,79 C4,79.5522847 4.44771525,80 5,80 L76,80 C76.5522847,80 77,79.5522847 77,79 L77,32 C77,31.4477153 76.5522847,31 76,31 L5,31 Z M5,27 L76,27 C78.7614237,27 81,29.2385763 81,32 L81,79 C81,81.7614237 78.7614237,84 76,84 L5,84 C2.23857625,84 3.38176876e-16,81.7614237 0,79 L0,32 C-3.38176876e-16,29.2385763 2.23857625,27 5,27 Z",
    id: "Rectangle",
    fill: "#9F9F9F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6011208,4 L114,4 C114.552285,4 115,4.44771525 115,5 L115,19.7249348 L119,23.5605469 L119,5 C119,2.23857625 116.761424,0 114,0 L94.4296875,0 L98.6011208,4 Z M114,4 C114.552285,4 115,4.44771525 115,5 L115,19.7249348 L119,23.5605469 L119,5 C119,2.23857625 116.761424,0 114,0 L94.4296875,0 L98.6011208,4 L114,4 Z",
    id: "Shape",
    fill: "#9F9F9F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    fill: "#979797",
    fillRule: "nonzero",
    points: "91 30.8284271 88.1715729 28 115 1.17157288 117.828427 4"
  }), /*#__PURE__*/React.createElement("use", {
    id: "Path",
    stroke: "#9F9F9F",
    mask: "url(#mask-2)",
    strokeWidth: 8,
    strokeLinejoin: "round",
    strokeDasharray: "13,4",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.c0cf6cdaac096cc96e7425526de13d83.svg";
export { ForwardRef as ReactComponent };